<template>
  <div id="div_userLogin" class="login-container">
    <div class="login-wrap">
      <div class="logo-wrap">
        <img class="logo" src="@/assets/img/logo.png" alt="">
        <span>登录中心</span>
      </div>
      <div class="main">
        <p class="banner">
          <img src="@/assets/img/12.png" alt="">
        </p>
        <div class="login-form">
          <div class="account-wrap">
            <h3>账号登录</h3>
            <el-form ref="form" :rules="rules" :model="form" label-width="80px">
              <el-form-item prop="username">
                <img src="@/assets/img/user.png" alt="">
                <el-input placeholder="输入账号" v-model="form.username"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <img src="@/assets/img/psd.png" alt="">
                <el-input placeholder="输入密码" v-model="form.password"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit()">马上登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">版权所有©：珍岛 Copyright©trueland</div>
  </div>
</template>

<script>
import { login } from '@/api'
import { setToken } from '@/base/cookie'

export default {
  components: {
  },
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit() {
      console.log(this.$refs.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          login({ accountname: this.form.username, accountpassword: this.form.password }).then((data) => {
            if (data.code === 200) {
              this.$message.success(data.message)
              setToken(data.data)
              this.$store.commit('SETUSERINFO', {})
              this.$router.push({ path: `/home?username=${this.form.username}` })
            } else {
              this.$message.warning(data.message)
            }
          }).catch((e) => { console.log(e); });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  background-color: #eff7ff;
  overflow: auto;
  height: 100%;
  .login-wrap {
    min-height: 800px;
    height: calc(100% - 70px);
    // background: url(../img/bg.png) no-repeat center;
    background-size: cover;
    .logo-wrap {
      width: 1140px;
      height: 130px;
      line-height: 150px;
      margin: 0 auto;
      font-size: 18px;
      .logo {
        width: 145px;
        margin-right: 10px;
        float: left;
        margin-top: 32px;
      }
    }
    .main {
      width: 1140px;
      height: 657px;
      margin: 0 auto;
      .banner {
        width: 560px;
        background-color: #1266ff;
        height: 100%;
        overflow: hidden;
        float: left;
        img {
          width: 647px;
          margin-left: -46px;
        }
      }
      .login-form {
        padding: 40px 85px;
        background-color: #fff;
        position: relative;
        height: 100%;
        float: left;
        width: calc(100% - 560px);
        h3 {
          font-size: 30px;
          font-weight: 400;
          text-align: center;
          margin: 45px 0;
          color: #333;
        }
        img {
          position: absolute;
          top: 2%;
          z-index: 1;
          margin-left: 15px;
          margin-right: 8px;
          margin-top: 20px;
        }
        .el-input {
          width: 100%;
          height: 65px;
          border: 1px solid #dcdcdc;
          border-radius: 3px;
          margin-bottom: 15px;
          position: relative;
          /deep/.el-input__inner {
            padding-left: 50px;
            border: none;
            outline: none;
            font-size: 16px;
            height: 100%;
            padding-right: 10px;
            width: calc(100% - 50px);
          }
        }
      }
    }
  }
}
/deep/.el-form-item__content {
  button {
    width: 100%;
    height: 70px;
    color: #fff;
    background-color: #3381ff;
    outline: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
  }
}
.footer {
  height: 70px;
  line-height: 70px;
  text-align: center;
  font-size: 14px;
  color: #888888;
  background-color: #fff;
}
</style>
